export enum MeasurementType {
	Distance2D = "Distance2D",
	Distance3D = "Distance3D",
	Height = "Height",
	Area2D = "Area2D",
	Area3D = "Area3D",
	Angle = "Angle",
	Circle = "Circle",
}
